
/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 23.05.2016.
 */

import Schedule from './reduces-schedule';

export default Schedule;



// WEBPACK FOOTER //
// ./src/reducers/schedule/index.js